import {
  InputBase,
  InputBaseProps,
  SearchIcon,
  Theme,
  createStyles,
  fade,
  makeStyles,
} from '@forgeglobal/design-framework'
import { StyleDefaults } from 'isolated-design-library'
import React from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
        border: 'none',
      },
      marginLeft: 0,
      width: '100%',
    },
    searchIconWrapper: {
      width: theme.spacing(5),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px',
      color: StyleDefaults.color.light,
    },
    searchIcon: {
      marginBottom: theme.spacing(0.25),
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
      height: '100%',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 5),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '100%',
        '&:focus': {},
      },
    },
    inputFocussed: {
      border: 'none',
    },
  })
)

const SearchInputComponent: React.FC<InputBaseProps> = props => {
  const classes = useStyles()
  return (
    <div className={classes.search}>
      <div className={classes.searchIconWrapper}>
        <SearchIcon className={classes.searchIcon} />
      </div>
      <InputBase
        placeholder="Search…"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
          focused: classes.inputFocussed,
        }}
        inputProps={{ 'aria-label': 'search' }}
        {...props}
      />
    </div>
  )
}

export { SearchInputComponent }
